import { useEffect } from "react";

import { IFetcherRenderProps, TFetchFunction } from "../types";
import { useLazyFetcher } from "./useLazyFetcher";

/**
 * Accept async function that will be handled in effect
 *
 * @template P Async function params type
 * @template R Async function result type
 * @param {TFetchFunction<P, R>} fetchFunction
 * @param {P} [params] Parameters used on function invoke
 * @param {any[]} [deps]  If present, effect will only activate if the values in the list change.
 * @returns {IFetcherState<R>}
 */
export const useFetcher = <P, R>(
  fetchFunction: TFetchFunction<P, R>,
  params: P,
  deps: any[] = [],
): IFetcherRenderProps<R> => {
  const { fetch, ...state } = useLazyFetcher(fetchFunction, params, deps);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { fetch, ...state };
};
